import type { RouteRecordRaw } from 'vue-router';

import { Layouts } from '@/layouts/constants/Layout';
import { RouteNames } from '@/router/constants/routeName';

const deviceRoutes: RouteRecordRaw[] = [
  {
    path: '/devices',
    children: [
      {
        path: '',
        name: RouteNames.Devices,
        component: () => import('@/views/devices/ListDevices.vue'),
        meta: {
          layout: Layouts.MODERN,
        },
      },
      {
        path: 'deprecated',
        name: RouteNames.DeprecatedDevices,
        component: () => import('@/views/deprecated/AllDevicesView.vue'),
      },
      {
        path: ':deviceId',
        name: RouteNames.DeviceMachines,
        component: () => import('@/views/DeviceMachinesView.vue'),
      },
      {
        path: ':deviceId/deployment',
        name: RouteNames.DeviceDeployment,
        component: () => import('@/views/DeviceDeploymentView.vue'),
      },
      {
        path: ':deviceId/config',
        name: RouteNames.DeviceConfig,
        component: () => import('@/views/DeviceConfigView.vue'),
      },
      {
        path: ':deviceId/metrics',
        name: RouteNames.DeviceMetrics,
        component: () => import('@/views/DeviceMetricsView.vue'),
      },
      {
        path: ':deviceId/:machineName',
        name: RouteNames.Machine,
        component: () => import('@/views/MachineView.vue'),
      },
      {
        path: ':deviceId/:machineName/flows',
        name: RouteNames.Flows,
        component: () => import('@/views/AllFlowsView.vue'),
      },
      {
        path: ':deviceId/:machineName/flows/:flowId',
        name: RouteNames.Flow,
        component: () => import('@/views/FlowsView.vue'),
      },
    ],
  },
];

export default deviceRoutes;
